import SlideBox from './SlideBox';

export default SlideBox;
